import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BentoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bento"}/>
}
